import React from 'react';
import PaymentsAPI from 'api/PaymentsAPI';

interface IDeletePaymentModal {
  setDeleteMode: any;
  pay_id: string;
}

const DeletePaymentModal: React.FC<IDeletePaymentModal> = ({
  setDeleteMode,
  pay_id,
}) => {
  const deletePayment = async(payId: string) => {
    const res = await PaymentsAPI.deletePayment(payId);
    if (res?.success) {
      history.go(0);
    }
  };

  return (
    <div className='delete-payment-modal-container'>
      <div className='delete-payment-modal-header'>
        <div className='delete-payment-modal-header-content'>
          <div className='delete-payment-modal-header-icon'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
            >
              <path
                d='M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6'
                stroke='#D92D20'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
          <div className='delete-payment-modal-header-text-group'>
            <div className='delete-payment-modal-header-text-primary'>
              Delete payment method
            </div>
            <div className='delete-payment-modal-header-text-secondary'>
              Are you sure you want to delete your payment method?
            </div>
          </div>
        </div>
        <div
          className='delete-payment-modal-header-close'
          onClick={() => setDeleteMode(false)}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
          >
            <path
              d='M18 6L6 18M6 6L18 18'
              stroke='#85888E'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </div>
      </div>
      <div className='delete-method-modal-footer'>
        <div className='delete-method-modal-actions'>
          <div
            className='delete-method-modal-cancel'
            onClick={() => setDeleteMode(false)}
          >
            <div className='delete-method-modal-cancel-text'>Close</div>
          </div>
          <div
            className='delete-method-modal-delete'
            onClick={() => deletePayment(pay_id)}
          >
            <div className='delete-method-modal-delete-text'>Delete</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeletePaymentModal;
